import React, { Fragment, useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase/fireabase"; // import your Firestore instance
import { useParams } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { LuSendHorizonal } from "react-icons/lu";
import AllMessages from "../components/AllMessages";
import Avatar from "../components/Avatar";
import EditeMyProfiel from "../components/EditeMyProfiel";
import { FaCopy } from "react-icons/fa";
import { FiEdit3 } from "react-icons/fi";
const CreateMessage = () => {
  const [content, setContent] = useState("");
  const { id } = useParams();
  const auth = getAuth();

  const currentDate = new Date();
  const formattedDate = `${currentDate.toDateString()} ${currentDate.getHours()}:${currentDate.getMinutes()}`;

  const uid = auth.currentUser ? auth.currentUser.uid : "anonymous";

  const [senderData, setSenderData] = useState({});
  useEffect(() => {
    const fetchUserData = async () => {
      if (uid) {
        const userDoc = await getDoc(doc(db, "users", uid));
        setSenderData({ ...userDoc.data(), senderId: uid });
      }
    };

    fetchUserData();
  }, [uid]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    await addDoc(collection(db, "users", id, "messages"), {
      content,
      receiverId: id,
      senderData: senderData,
      ceatedAt: formattedDate,
    });

    setContent("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
      }}
    >
      <div className="w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 xl:w-4/12">
        <label for="OrderNotes" class="sr-only">
          Order notes
        </label>

        <div class="overflow-hidden rounded-lg border border-gray-200 shadow-sm">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="اكتب رسالتك هنا"
            required
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              padding: "10px",
              color: "black",
              direction: "rtl",
            }}
            rows="12"
            className="form-textarea block w-full sm:text-sm sm:leading-5 sm:h-48 md:h-64 lg:h-80 xl:h-96"
          ></textarea>

          <div class="flex items-center justify-end gap-2  p-3">
            <button
              type="button"
              class="rounded bg-red-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-600"
              onClick={() => setContent("")}
            >
              مسح الرسالة
            </button>

            <button
              type="submit"
              class="rounded px-3 py-1.5 text-sm font-medium flex items-center gap-1"
              style={{ backgroundColor: "#f0ad4e", color: "#333333" }}
            >
              <LuSendHorizonal size="20px" />
              <span style={{ marginRight: "5px" }}> ارسال الرسالة</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

const ProfileLink = () => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    setButtonText({
      text: "Copied!",
      color: "black",
      backgroundColor: "#C5E898",
    });
    setTimeout(() => {
      setButtonText({
        text: "Copy URL",
        color: "white",
        backgroundColor: "#83A2FF",
      });
    }, 2000);
  };

  const [buttonText, setButtonText] = useState({
    text: "Copy URL",
    color: "white",
    backgroundColor: "#83A2FF",
  });

  const isSmallScreen = window.innerWidth < 768;

  const styles = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  };

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
      }}
    >
      <p>شارك رابط هذه الصفحة مع اصدقائك ليتمكنوا من ارسال رسائل لك</p>
      <div style={styles}>
        <input
          type="text"
          value={window.location.href}
          readOnly
          style={{
            width: "300px",
            border: "1px solid white",
            margin: "10px",
            borderRadius: "10px",
            padding: "10px",
          }}
        />
        <button
          onClick={copyToClipboard}
          style={{
            borderRadius: "10px",
            backgroundColor: buttonText.backgroundColor,
            color: buttonText.color,
            fontWeight: "bold",
            fontSize: "18px",
            cursor: "pointer",
            padding: "10px",
          }}
        >
          <FaCopy size="1em" />
        </button>
      </div>
    </div>
  );
};

const MyProfile = () => {
  const [user, setUser] = useState(null);
  const auth = getAuth();
  const { id } = useParams();
  //   id for the user logged in
  const userLoginID = auth.currentUser ? auth.currentUser.uid : "anonymous";
  useEffect(() => {
    const fetchUserData = async () => {
      if (id) {
        const userDoc = await getDoc(doc(db, "users", id));
        setUser(userDoc.data());
      }
    };

    fetchUserData();
  }, [id]);

  const [open, setOpen] = useState(false);
  const handelClose = () => {
    setOpen(false);
  };
  const handelOpen = () => {
    setOpen(true);
  };

  return (
    <div
      style={{
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      {userLoginID === id && user && (
        <EditeMyProfiel
          open={open}
          handelClose={handelClose}
          handelOpen={handelOpen}
          id={id}
          setUser={setUser}
          user={user}
        />
      )}

      {user ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "20px",
            padding: "20px",
          }}
        >
          <div className="relative">
            {userLoginID === id && user && (
              <p
                className="absolute -top-4 -right-5 text-white bg-gray-500 px-2 py-1 rounded-full flex items-center gap-1"
                onClick={() => {
                  handelOpen();
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <FiEdit3 size="1.5em" />
              </p>
            )}

            {user.photoURL ? (
              <img
                src={user.photoURL}
                alt="user"
                width="100px"
                height="100px"
                style={{ borderRadius: "50%" }}
              />
            ) : (
              <Avatar Name={user.email} />
            )}
          </div>
          <h1>{user.name || "No Name"}</h1>
        </div>
      ) : (
        <p>Loading...</p>
      )}
      {userLoginID !== id && <CreateMessage />}
      {userLoginID === id && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <ProfileLink />
          <AllMessages />
        </div>
      )}
    </div>
  );
};

export default MyProfile;
